import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug, hasErrors } from "../../utils";
import * as validationService from "../../devices/add-device-modal/validationService";
import { CentralCredentialsCardInput } from "./CentralCredentialsCardInput";
import { CardTypes, CentralCredentialsCardService } from "./CentralCredentialsCardService";
import { getCentralCredentialsById } from "../authService";

import { Spinner } from "../../view/Spinner";

function CentralCredentialsCard({ errors, handleClose, cardType = CardTypes.CREATE, centralCredentialsId }) {

    const valid = !hasErrors(errors);
    const isCreateMode = cardType === CardTypes.CREATE;
    const formId = "oct-central-credentials-form";

    const [loading, setLoading] = useState(true);
    const [ccname, setCCName] = useState(""); 
    const [username, setUsername] = useState(""); 
    const [password, setPassword] = useState("");
    const [passwordChanged, setPasswordChanged] = useState(false);

    // const [valid, setValid]=useState(!hasErrors(errors))

    const centralCredentialsCardService = new CentralCredentialsCardService(cardType, handleClose);

    const fetchData = async () => {
        if (centralCredentialsId && cardType === CardTypes.EDIT) {
            try {
                const centralCredentials = await getCentralCredentialsById(centralCredentialsId);
                if (centralCredentials) {
                    setCCName(centralCredentials.ccname)
                    setUsername(centralCredentials.username);                    
                    setPassword('******');                 
                }
            } catch (error) {
                console.error('Error:', error);
            }
        } else {
            validationService.validateNotEmpty(ccname, 'ccname');
            validationService.validateNotEmpty(username, 'username');
            validationService.validateNotEmpty(password, 'password');
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchData();

        return () => {
            validationService.cleanState();
        };
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])//[authServerId, cardType, ip, baseDN, serviceName, password, type]);


    const onCCNameChange = (value) => {
        validationService.validateNotEmpty(value, 'ccname');
        setCCName(value);
    }

    const onUsernameChange = (value) => {
        validationService.validateNotEmpty(value, 'username');
        setUsername(value);
    }

    const onPasswordChange = (value) => {
        validationService.validateNotEmpty(value, 'password');
        setPassword(value);
        setPasswordChanged(true);
    }

    const onPasswordFocus = () => {
        if (!passwordChanged) {
            setPassword('');
            setPasswordChanged(true);
        }
    }

    const isPasswordValid = () => password && password.length >= 1;
    const canSubmit = valid && isPasswordValid();


    return (
        <>
            <div className="modal-body modal-v2-body oct_auth-v2-modal-body">
                {loading ? (
                    <div className="oct_auth-v2-modal-loading">
                        <Spinner />
                    </div>
                ) : (
                    <form
                        id={formId}
                        className="oct_auth-v2-form modal-v2-form"
                        autoComplete="off"
                        onSubmit={(event) => {
                            event.preventDefault();
                            if (!canSubmit) {
                                return;
                            }

                            const payload = {
                                ccname,
                                username,
                                password,
                                passwordChanged,
                                id: centralCredentialsId
                            };

                            if (isCreateMode) {
                                centralCredentialsCardService.onCreate(payload);
                                return;
                            }

                            centralCredentialsCardService.onSave(payload);
                        }}
                    >
                        <div className="oct_auth-v2-form-grid oct_auth-v2-form-grid--single">
                            <CentralCredentialsCardInput
                                label={'Name'}
                                value={ccname}
                                onChange={onCCNameChange}
                                valid={ccname}
                                required
                            />

                            <CentralCredentialsCardInput
                                label={'Username'}
                                value={username}
                                onChange={onUsernameChange}
                                valid={username}
                                required
                            />

                            <CentralCredentialsCardInput
                                label={'Password'}
                                value={password}
                                type={'password'}
                                onFocus={() => onPasswordFocus()}
                                onChange={onPasswordChange}
                                valid={isPasswordValid()}
                                required
                            />
                        </div>
                    </form>
                )}
            </div>

            <div className="modal-footer modal-v2-footer oct_auth-v2-modal-footer">
                <div className="modal-v2-footer-note">
                    <span className="modal-v2-footer-note-star">*</span> Required fields
                </div>
                <div className="modal-v2-footer-actions oct_auth-v2-modal-actions">
                    <button type="button" className="btn modal-v2-btn modal-v2-btn-outline oct_auth-v2-modal-btn" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="submit"
                        form={formId}
                        className="btn modal-v2-btn modal-v2-btn-primary oct_auth-v2-modal-btn"
                        disabled={loading || !canSubmit}
                    >
                        {isCreateMode ? "Create" : "Save"}
                    </button>
                </div>
            </div>
        </>
    )
}

function mapStateToProps(state) {
    debug("CentralCredentialsCard mapStateToProps:", state);
    const validation = state.validation;
    return {
        errors: validation || {},
    }
}

export default connect(mapStateToProps)(CentralCredentialsCard);
